<template>
  <div id="bto-design-customize-size" v-if="jewelleryTypeCode == '1'">
    <h2>サイズ：</h2>
    <p class="help">
      手首サイズ＋1.5cmが適したサイズです。<span>（ゆったり：＋2cm）</span>
    </p>
    <ul id="bto-design-customize-sizelist">
      <li v-for="(size, key) in sizeDataList" :key="key">
        <button
          type="button"
          :value="size.accessorySize_id"
          :class="getIsCurrentClass(size.accessorySize_id)"
          @click="switchAccessorySize(size.accessorySize_id)"
        >
          {{ size.name }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import accessoryItemRestRepository from "@/mixins/BtoPanel/RepositoryAccessoryItemRest.js";

export default {
  name: "DesignCustomizeSize",

  mixins: [accessoryItemRestRepository],

  props: {
    jewelleryItemId: {
      type: String,
    },
    jewelleryItemCode: {
      type: String,
    },
    jewelleryTypeCode: {
      type: String,
    },
    sizeDataList: {
      type: Object,
    },
    designId: {
      type: Object,
    },
  },

  computed: {
    ...mapState({
      currentSizeId: (state) => state.current_size_id,
    }),
  },

  methods: {
    /**
     * アクセサリサイズIDを受け取って、現在のサイズの場合はクラスを返す
     */
    getIsCurrentClass(sizeId) {
      return this.currentSizeId == sizeId ? "current_size" : "";
    },

    /**
     * アクセサリサイズIDを受け取って、vuexの現在のサイズIDを更新し、合計価格を問い合わせる
     */
    switchAccessorySize(sizeId) {
      this.$store.commit("update_size_id", sizeId);
      this.delayUpdateBtoResult();
    },

    ...mapActions(["update_bto_result"]),
  },
};
</script>

<style scoped lang="stylus">

#bto-design-customize-sizelist
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr

@screen lg
  #bto-design-customize-sizelist
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr
    font-size: 0.8em

@css {
  #bto-design-customize-size {
    background-color: #efebe3;
    @apply px-2 py-4 text-left mb-4 mt-4 lg:mt-0
  }
  #bto-design-customize-size .help span {
    @apply block sm:inline
  }
  #bto-design-customize-sizelist {
    @apply grid gap-2
  }
  #bto-design-customize-sizelist li {
    @apply inline-block whitespace-nowrap
  }
  #bto-design-customize-sizelist li button {
    @apply w-full bg-white p-1 border-solid border-gray-200 border-2 focus:outline-none
  }
  #bto-design-customize-sizelist .current_size {
    border-color: #fb6e81;
    color: #fb6e81;
    @apply border-dashed border-2
  }
}
</style>
